import { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import type { RootState } from '@/app/store/store';
import type { StoreLocatorService } from '../types/physicalStoreServiceContracts';
import { toStoreCityGroupsVm } from '../viewModels/physicalStore.vm';
import type { StoreCityGroupVm } from '../viewModels/physicalStore.vm';

type UseStoreLocatorArgs = {
  service: StoreLocatorService;
};

export function useStoreLocator({ service }: UseStoreLocatorArgs) {
  useEffect(() => {
    service.prefetchStoreLocator();
  }, [service]);

  const storeLocatorData = useSelector((state: RootState) => service.selectStoreLocator(state));

  const cityToStoresMap = storeLocatorData?.cityToStoresMap;
  const isLoading = cityToStoresMap === undefined;

  const cityGroups = useMemo<StoreCityGroupVm[]>(
    () => toStoreCityGroupsVm(service.getSortedCityGroups(cityToStoresMap)),
    [service, cityToStoresMap]
  );

  const storeCount =
    typeof storeLocatorData?.numberOfStores === 'number' ? storeLocatorData.numberOfStores : null;

  return {
    cityToStoresMap,
    cityGroups,
    isLoading,
    storeCount,
    seoSchema: storeLocatorData?.seoSchema,
    currentCityName: storeLocatorData?.currentCityName,
    currentCityIsInList: storeLocatorData?.currentCityIsInList,
  };
}
